import { DeleteFile } from '../../../../../services/FileService'

interface FileUploadQuestion {
  survey: { uploadFiles: (question: any, fileName: string, files: File[], callback: (data: any, errors: any) => void) => void }
  uploadedFileName: string | null
  uploadedFileKey: string | null
}

export function handleSurveyFileSelect (question: FileUploadQuestion, file: File | undefined): void {
  if (file !== undefined) {
    question.survey.uploadFiles(question, file.name, [file], (data: any, errors: any) => {
      if (errors != null && errors.length > 0) {
        console.error('File upload errors:', errors)
      }
    })
  }
}

export async function deleteSurveyFile (question: FileUploadQuestion): Promise<void> {
  const key = question.uploadedFileKey
  if (key != null && key !== '') {
    try {
      await DeleteFile(key)
    } catch (e) {
      console.error('Failed to delete file from server', e)
    }
  }
  question.uploadedFileName = null
  question.uploadedFileKey = null
}
